import { DEFAULT_OUTBOUND_FORM_VALUES } from '../schemas/outboundSchema';

/**
 * Nested stock-issue detail → 出庫表單值。
 * `availableQty` 先以目前 qty 墊底；載入 candidates 後再合併可用量。
 *
 * @param {object | null | undefined} detail
 */
export function mapStockIssueDetailToOutboundForm(detail) {
  if (!detail) {
    return { ...DEFAULT_OUTBOUND_FORM_VALUES, lines: [] };
  }

  return {
    issueDate: detail.issueDate ?? '',
    issueReason: detail.issueReason ?? '',
    remark: detail.remark ?? '',
    lines: (detail.lines ?? []).map((line) => mapDetailLineToOutboundFormLine(line)),
  };
}

function mapDetailLineToOutboundFormLine(line) {
  const sourceType = line?.sourceType === 'PENDING_ALLOCATION'
    ? 'PENDING_ALLOCATION'
    : 'INVENTORY_STOCK';
  const invStockId = line?.invStockId ?? line?.invStock?.id ?? null;
  const pendingAllocationId = line?.pendingAllocationId
    ?? line?.pendingAllocation?.id
    ?? null;
  const sourceId = sourceType === 'PENDING_ALLOCATION'
    ? pendingAllocationId
    : invStockId;
  const qty = Number(line?.qty);
  const safeQty = Number.isFinite(qty) ? qty : 0;

  return {
    sourceKey: sourceId ? `${sourceType}:${sourceId}` : `${sourceType}:`,
    sourceType,
    invStockId: sourceType === 'PENDING_ALLOCATION' ? null : invStockId,
    pendingAllocationId: sourceType === 'PENDING_ALLOCATION'
      ? pendingAllocationId
      : null,
    mtrId: line?.mtr?.id ?? line?.mtrId ?? '',
    mtrNo: line?.mtr?.mtrNo ?? '',
    mtrName: line?.mtr?.name ?? '',
    stockNo: line?.invStock?.stockNo ?? line?.stockNo ?? null,
    availableQty: safeQty,
    qty: safeQty,
  };
}

/**
 * 以 candidates 來源可用量抬高／更新已選明細的 availableQty（編輯草稿時）。
 *
 * @param {Array} lines
 * @param {Array} materials normalizeStockIssueCandidates().materials
 */
export function mergeOutboundLinesAvailableQty(lines = [], materials = []) {
  const availableByKey = {};
  (materials ?? []).forEach((material) => {
    (material?.sources ?? []).forEach((source) => {
      if (source?.sourceKey) {
        availableByKey[source.sourceKey] = Number(source.qty) || 0;
      }
    });
  });

  return (lines ?? []).map((line) => {
    const candidateQty = availableByKey[line?.sourceKey];
    const currentQty = Number(line?.qty) || 0;
    if (candidateQty == null) {
      return {
        ...line,
        availableQty: Math.max(Number(line?.availableQty) || 0, currentQty),
      };
    }
    return {
      ...line,
      availableQty: Math.max(candidateQty, currentQty),
    };
  });
}
